import { render, staticRenderFns } from "./RatedList.vue?vue&type=template&id=3c59a453&scoped=true"
import script from "./RatedList.vue?vue&type=script&lang=js"
export * from "./RatedList.vue?vue&type=script&lang=js"
import style1 from "./RatedList.vue?vue&type=style&index=1&id=3c59a453&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c59a453",
  null
  
)

export default component.exports